import React from 'react';
import useAnalyticsClick from '@kbbsdk/global-sdk/analytics/react/useAnalyticsClick';
import { Button } from '@argo/ui-elements';
import PropTypes from 'prop-types';

// Generated by GitHub Copilot
function CIMButton({
  text = '',
  target = '',
  rel = '',
  href = '',
  gaEventResult = '',
  buttonType = 'primary',
  ...rest
}) {
  const onAnalyticsClick = useAnalyticsClick(() => {
    const analyticsData = {
      event: 'analytics_event',
      eventElement: 'cim',
      eventAction: 'click',
      // eventResult: `${gaEventResult}`,
      eventNonInteractive: true,
    };

    return {
      googleAnalytics: {
        props: analyticsData,
      },
    };
  });

  return (
    <Button
      onClick={onAnalyticsClick()}
      buttonType={buttonType}
      text={text}
      minimizeSize
      disabled={false}
      href={href}
      target={target}
      enableCapitalize={false}
      sizeType="large"
      isSmallText
      fontSizeOverride="16"
      preventTextWrap
      {...rest}
      rel={rel}
    />
  );
}

CIMButton.propTypes = {
  text: PropTypes.string,
  href: PropTypes.string,
  gaEventResult: PropTypes.string,
  buttonType: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string,
};

CIMButton.defaultProps = {
  text: undefined,
  href: undefined,
  gaEventResult: undefined,
  buttonType: undefined,
  target: undefined,
  rel: undefined,
};

export default CIMButton;
